/** Gap between items in Spartan product list / grid layouts (16px / 24px). */
export const SPARTAN_PRODUCT_LIST_GAP_CLASS_NAME = 'gap-4 md:gap-6';

/** Gap between items in Spartan product compact lists (8px / 16px). */
export const SPARTAN_PRODUCT_COMPACT_LIST_GAP_CLASS_NAME = 'gap-2 md:gap-4';
